import React, { useCallback } from 'react';
import Template from './template';
import { ServiceDocChecked } from 'components';
import { useServiceStatus } from 'hooks';
import moment from 'moment';
import { APP_GUIDE } from 'router/PageUrl';

function ServiceDocCheckedView(): React.ReactElement {
  const { serviceType, serviceState } = useServiceStatus();
  const { createdDate, interviewExpectation, serviceStatusHistoryList } =
    serviceState;
  const checkedDate: string | undefined = serviceStatusHistoryList.find(
    (item) => item.serviceDocStatus === 'doc_checked'
  )?.createDate;

  const onClickCallback = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      window.open(`${APP_GUIDE.url}/${serviceType}`);
    },
    [serviceType]
  );

  const docCheckedProps = {
    serviceType: serviceType,
    createdDate: moment(createdDate).format('YYYY년 MM월 DD일'),
    checkedDate: checkedDate
      ? moment(checkedDate).format('YYYY년 MM월 DD일')
      : '-',
    interviewExpectation: interviewExpectation
      ? JSON.parse(interviewExpectation)
      : [],
    onClick: onClickCallback,
  };

  return (
    <Template>
      <ServiceDocChecked {...docCheckedProps} />
    </Template>
  );
}

export default ServiceDocCheckedView;
